import React from 'react';
import './AutoSyncBodyKeyVerification.scss';
import {
  AUTO_SYNC_MODAL_THAI,
  BODY_KEY_VERIFY_ERROR,
} from '../../challengeConstants';

export default function AutoSyncBodyKeyVerification({
  bodyKeyId,
  onChangeHandler,
  onClose,
  onVerify,
  validationFailed,
  errorDetail,
  amwayNumberError,
}) {
  const supportCustomerDetail = (support, idx = null) => (
    <span key={support} className={`${errorDetail.length === 4 && idx === 3 ? 'error-text' : ''}`}>
      {support}
      <br />
    </span>
  );
  return (
    <div className="auto-sync-body">
      <div className="auto-sync-body-title">{AUTO_SYNC_MODAL_THAI.TITLE} </div>
      <div className="auto-sync-body-info">
        {errorDetail.length > 0
          ? errorDetail.map((detail, idx) => supportCustomerDetail(detail, idx))
          : AUTO_SYNC_MODAL_THAI.SUPPORT_CUSTOMER.map(supportCustomerDetail)}
      </div>
      <div className="auto-sync-body-input-field">
        <input
          className={`auto-sync-input-box ${validationFailed ? 'error-value' : ''
            }`}
          value={bodyKeyId}
          onChange={onChangeHandler}
          name="bodyKeyId"
          inputMode="tel"
          type="tel"
          regex={/[0]{1}[6-9]{1}[0-9]{1}[0-9]{7}/}
          maxLength="10"
        />
      </div>
      <div className="auto-sync-body-action-box">
        <button className="btn btn-outline-black" onClick={onClose}>
          {AUTO_SYNC_MODAL_THAI.CANCEL_BTN}
        </button>
        <button
          className="btn btn-green btn-green-linear"
          disabled={!bodyKeyId || validationFailed}
          onClick={() => {
            if (!validationFailed) {
              onVerify();
            }
          }}
        >
          <span className="text-color-white">
            {AUTO_SYNC_MODAL_THAI.SUCCESS_BTN}
          </span>
        </button>
      </div>
    </div>
  );
}
